import React from 'react';
import PropTypes from 'prop-types';
import { PricePromiseTable, BLUE_BOX } from './PricePromiseTable.jsx';
import { getDisplayedTable } from './common.js';
import uiLocale from '../../../utils/UILocale.js';

const MAX_ROWS_COLLAPSED = 4;

const WE_WILL_MATCH_HEADER = 'component.price-promise-blue-box.we-will-match';
const WE_WILL_MATCH_BODY = 'component.price-promise-blue-box.text';

const EXCLUSIVE_HEADER = 'component.price-promise-blue-box.exclusive';
const EXCLUSIVE_BODY = 'component.price-promise-blue-box.exclusive.text';

const NODATA_HEADER = 'component.price-promise-blue-box.no-data';
const NODATA_BODY = 'component.price-promise-blue-box.no-data.text';

const GOT_IT = 'component.price-promise-blue-box.got-it';
const SHOW_MORE = 'component.price-promise.show-more';

export default function BlueBoxContent(props) {
  const { exclusive, hide, expandPricePromiseTab } = props;

  const competitorsTable = exclusive ? [] : props.competitorsTable;

  const table = getDisplayedTable(competitorsTable, false, MAX_ROWS_COLLAPSED);

  const headerText = uiLocale.getString(
    exclusive // eslint-disable-line no-nested-ternary
      ? EXCLUSIVE_HEADER
      : (
        competitorsTable.length > 0
          ? WE_WILL_MATCH_HEADER
          : NODATA_HEADER
      )
  );
  const bodyText = uiLocale.getString(
    exclusive // eslint-disable-line no-nested-ternary
      ? EXCLUSIVE_BODY
      : (
        competitorsTable.length > 0
          ? WE_WILL_MATCH_BODY
          : NODATA_BODY
      )
  );
  const gotItText = uiLocale.getString(GOT_IT);
  const showMoreText = uiLocale.getString(SHOW_MORE);

  return (
    <div>
      <div className={'price-promise-bluebox-header'}>
        <span
          className={`header ${exclusive ? '' : 'has-icon'}`}
          dangerouslySetInnerHTML={{ __html: headerText }}
        />
                
        <a className={'close'} onClick={hide}>{ gotItText }</a>

      </div>

      <div
        className={'price-promise-bluebox-text'}
        dangerouslySetInnerHTML={{ __html: bodyText }}
      />

      <PricePromiseTable table={table} location={BLUE_BOX} />

      { competitorsTable.length > MAX_ROWS_COLLAPSED && (
        <a
          className={'anchor-lk price-promise-bluebox-show-more'}
          onClick={() => { expandPricePromiseTab(); hide(); }}
        >
          { showMoreText }
        </a>
      )}
    </div>
  );
}

BlueBoxContent.propTypes = {
  exclusive: PropTypes.bool.isRequired,
  competitorsTable: PropTypes.array.isRequired, // eslint-disable-line react/forbid-prop-types
  hide: PropTypes.func.isRequired,
  expandPricePromiseTab: PropTypes.func.isRequired
};
